export const translations = {
  en: {
    nav: {
      shop: "SHOP",
      events: "EVENTS",
      artists: "ROSTER",
      lookbook: "LOOKBOOK",
      blog: "JOURNAL",
      about: "ABOUT",
      cart: "CART",
      tickets: "TICKETS",
      shop_all: "ALL",
      shop_by_wrestler: "BY WRESTLER",
      shop_by_artist: "BY ARTIST",
    },
    hero: {
      tagline: "WRESTLING / MUSIC / EVENTS",
      headline: "WEAR THE CULT.",
      subline:
        "Apparel forged in Porto. Worn in the ring, on stage, in the pit. Drops every season — limited, loud, and entirely ours.",
      cta_shop: "SHOP THE DROP",
      cta_events: "UPCOMING EVENTS",
    },
    sections: {
      featured: "FEATURED PIECES",
      featured_sub: "Latest drops from the Kultopia roster",
      shop_collections: "SHOP BY COLLECTION",
      lookbook: "LOOKBOOK",
      lookbook_sub: "Capsule 02 — IN THE RING",
      events: "UPCOMING EVENTS",
      events_sub: "Where the cult meets",
      roster: "THE ROSTER",
      roster_sub: "Wrestlers, musicians, artists",
      journal: "JOURNAL",
      journal_sub: "News, drops, interviews",
      newsletter_title: "JOIN THE CULT.",
      newsletter_sub: "Drops, events, and the occasional secret. No spam.",
      newsletter_cta: "SUBSCRIBE",
      newsletter_placeholder: "your@email.com",
      newsletter_success: "Welcome to the cult.",
    },
    product: {
      add_to_cart: "ADD TO CART",
      sold_out: "SOLD OUT",
      size: "SIZE",
      color: "COLOR",
      details: "DETAILS",
      shipping: "Shipping calculated at checkout. Ships from Portugal worldwide.",
      view_all: "VIEW ALL",
      sizes_required: "Pick a size first",
    },
    cart: {
      title: "YOUR CART",
      empty: "Your cart is empty.",
      continue: "CONTINUE SHOPPING",
      subtotal: "SUBTOTAL",
      checkout: "CHECKOUT",
      remove: "Remove",
    },
    checkout: {
      title: "CHECKOUT",
      contact: "CONTACT",
      email: "Email",
      name: "Full name",
      shipping: "SHIPPING",
      address: "Street address",
      apartment: "Apartment / suite / floor (optional)",
      city: "City",
      postal: "Postal code",
      country: "Country",
      notes: "Notes (optional)",
      place_order: "PLACE ORDER",
      success: "ORDER PLACED.",
      success_sub: "Your order has been received. We'll be in touch.",
      back_home: "BACK TO HOME",
      mock_disclaimer: "Demo checkout — no real payment is taken.",
    },
    events: {
      title: "EVENTS",
      sub: "Wrestling cards, gigs, capsule launches",
      tickets: "TICKETS",
      sold_out: "SOLD OUT",
    },
    tickets: {
      title: "BUY TICKETS",
      sub: "Wrestling shows, gigs, festivals — all the cult's nights out.",
      pick_event: "PICK YOUR EVENT",
      qty: "QUANTITY",
      price_per: "PER TICKET",
      total: "TOTAL",
      checkout: "GET TICKETS",
      success: "TICKETS LOCKED IN.",
      success_sub: "Your tickets have been issued. Show this code at the door.",
      mock_disclaimer: "Demo ticket sales — no real payment is taken.",
      music_price: "MUSIC SHOW",
      wrestling_price: "WRESTLING NIGHT",
    },
    artists: {
      title: "THE ROSTER",
      sub: "The faces, the voices, the bodies behind every drop.",
    },
    about: {
      title: "ABOUT KULTOPIA",
      sub: "Apparel from the cult, for the cult.",
      body_1:
        "Kultopia was born in Porto in 2023 — a clothing label by and for the people who actually show up. To wrestling shows. To dingy music venues. To the after-after-party.",
      body_2:
        "We design every piece with the people who wear it. Wrestlers get signature lines. Musicians get capsule drops. Events get tour merch the day they happen.",
      body_3:
        "We don't chase trends. We chase shows. We chase pits. We chase the kind of nights you'll still be telling people about ten years from now.",
      stats_drops: "DROPS",
      stats_artists: "ARTISTS",
      stats_events: "EVENTS",
    },
    blog: {
      title: "JOURNAL",
      sub: "Writing about the things we make and the people who wear them.",
      read: "READ",
    },
    footer: {
      tag: "WRESTLING / MUSIC / EVENTS",
      contact: "CONTACT",
      shipping: "SHIPPING & RETURNS",
      privacy: "PRIVACY",
      follow: "FOLLOW",
      rights: "© 2026 KULTOPIA APPAREL. ALL RIGHTS RESERVED.",
    },
  },
  pt: {
    nav: {
      shop: "LOJA",
      events: "EVENTOS",
      artists: "ROSTER",
      lookbook: "LOOKBOOK",
      blog: "JOURNAL",
      about: "SOBRE",
      cart: "CARRINHO",
      tickets: "BILHETES",
      shop_all: "TODA A LOJA",
      shop_wrestling: "WRESTLING",
      shop_music: "MÚSICA",
      shop_events: "MERCH EVENTOS",
      shop_by_wrestler: "POR WRESTLER",
      shop_by_artist: "POR ARTISTA",
    },
    hero: {
      tagline: "WRESTLING / MÚSICA / EVENTOS",
      headline: "VESTE O CULTO.",
      subline:
        "Roupa forjada no Porto. Usada no ringue, no palco, no pit. Drops todas as estações — limitados, altos e nossos.",
      cta_shop: "VER A DROP",
      cta_events: "PRÓXIMOS EVENTOS",
    },
    sections: {
      featured: "PEÇAS EM DESTAQUE",
      featured_sub: "Últimos lançamentos do roster Kultopia",
      shop_collections: "POR COLEÇÃO",
      lookbook: "LOOKBOOK",
      lookbook_sub: "Cápsula 02 — DENTRO DO RINGUE",
      events: "PRÓXIMOS EVENTOS",
      events_sub: "Onde o culto se encontra",
      roster: "O ROSTER",
      roster_sub: "Wrestlers, músicos, artistas",
      journal: "JOURNAL",
      journal_sub: "Notícias, drops, entrevistas",
      newsletter_title: "JUNTA-TE AO CULTO.",
      newsletter_sub: "Drops, eventos e algum segredo. Sem spam.",
      newsletter_cta: "SUBSCREVER",
      newsletter_placeholder: "o-teu@email.com",
      newsletter_success: "Bem-vindo ao culto.",
    },
    product: {
      add_to_cart: "ADICIONAR AO CARRINHO",
      sold_out: "ESGOTADO",
      size: "TAMANHO",
      color: "COR",
      details: "DETALHES",
      shipping: "Portes calculados no checkout. Envia de Portugal para todo o mundo.",
      view_all: "VER TUDO",
      sizes_required: "Escolhe um tamanho primeiro",
    },
    cart: {
      title: "O TEU CARRINHO",
      empty: "O teu carrinho está vazio.",
      continue: "CONTINUAR A COMPRAR",
      subtotal: "SUBTOTAL",
      checkout: "FINALIZAR COMPRA",
      remove: "Remover",
    },
    checkout: {
      title: "CHECKOUT",
      contact: "CONTACTO",
      email: "Email",
      name: "Nome completo",
      shipping: "ENVIO",
      address: "Morada",
      apartment: "Apartamento / andar (opcional)",
      city: "Cidade",
      postal: "Código postal",
      country: "País",
      notes: "Notas (opcional)",
      place_order: "FINALIZAR ENCOMENDA",
      success: "ENCOMENDA EFETUADA.",
      success_sub: "A tua encomenda foi recebida. Entramos em contacto.",
      back_home: "VOLTAR AO INÍCIO",
      mock_disclaimer: "Checkout demo — não é cobrado pagamento real.",
    },
    events: {
      title: "EVENTOS",
      sub: "Cartazes de wrestling, concertos, lançamentos de cápsula",
      tickets: "BILHETES",
      sold_out: "ESGOTADO",
    },
    tickets: {
      title: "COMPRAR BILHETES",
      sub: "Shows de wrestling, concertos, festivais — as noites do culto.",
      pick_event: "ESCOLHE O EVENTO",
      qty: "QUANTIDADE",
      price_per: "POR BILHETE",
      total: "TOTAL",
      checkout: "COMPRAR BILHETES",
      success: "BILHETES GARANTIDOS.",
      success_sub: "Os teus bilhetes foram emitidos. Mostra este código à porta.",
      mock_disclaimer: "Venda demo — não é cobrado pagamento real.",
      music_price: "CONCERTO",
      wrestling_price: "NOITE DE WRESTLING",
    },
    artists: {
      title: "O ROSTER",
      sub: "Os rostos, as vozes e os corpos por detrás de cada drop.",
    },
    about: {
      title: "SOBRE A KULTOPIA",
      sub: "Roupa do culto, para o culto.",
      body_1:
        "A Kultopia nasceu no Porto em 2023 — uma marca de roupa por e para as pessoas que aparecem. Aos shows de wrestling. Às salas de concertos pequenas. À after-after-party.",
      body_2:
        "Desenhamos cada peça com quem a usa. Wrestlers ganham linhas signature. Músicos ganham cápsulas. Eventos ganham merch de tour no próprio dia.",
      body_3:
        "Não corremos atrás de tendências. Corremos atrás de shows. Atrás de pits. Atrás daquelas noites que vais contar daqui a dez anos.",
      stats_drops: "DROPS",
      stats_artists: "ARTISTAS",
      stats_events: "EVENTOS",
    },
    blog: {
      title: "JOURNAL",
      sub: "Escrevemos sobre o que fazemos e sobre quem o usa.",
      read: "LER",
    },
    footer: {
      tag: "WRESTLING / MÚSICA / EVENTOS",
      contact: "CONTACTO",
      shipping: "ENVIOS & DEVOLUÇÕES",
      privacy: "PRIVACIDADE",
      follow: "SEGUIR",
      rights: "© 2026 KULTOPIA APPAREL. TODOS OS DIREITOS RESERVADOS.",
    },
  },
};

export const langField = (item, base, lang) => {
  if (lang === "pt") {
    const k = `${base}_pt`;
    return item[k] || item[base];
  }
  return item[base];
};
